import { z } from 'zod'

import { DateZod } from '../common'

export const PiloteUserAccountZod = z.object({
  piloteUserId: z.number(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().nullable(),
  permissions: z.string().array(),
  centralId: z.number().nullable(),
  active: z.boolean(),
  syncedAt: DateZod,
})
export type PiloteUserAccount = z.infer<typeof PiloteUserAccountZod>
